import React from 'react';

import styles from './userFollowersPageStyles.scss';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import UserFollowersListContainer from 'buyside/components/container/UserAccount/UserFollowersListContainer';

import { useCurrentUserAccountFollowersQuery } from 'interfaces/graphql-typings';

import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

const UserFollowersPage: React.FC<{}> = (): React.ReactElement => {
  const { loading, data } = useCurrentUserAccountFollowersQuery();

  if (loading || !data?.currentUser) return <LoadingSpinner size={SIZES.LARGE} />;

  const { activeFollowersCount } = data.currentUser;

  return (
    <>
      <div className={styles.pageTitle}>Your Followers</div>
      {activeFollowersCount ? (
        <ErrorBoundary pageName="followers list">
          <UserFollowersListContainer />
        </ErrorBoundary>
      ) : (
        <div className={styles.noContentMsg}>
          <p>You currently don't have any followers.</p>
        </div>
      )}
    </>
  );
};

export default UserFollowersPage;
